import { apiBaseUrl } from 'app/src/msw/companyagreement/api/apiBaseUrl'
import { categoryCollection } from 'app/src/msw/companyagreement/initialSeed/categories'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

/**
 * Handles GET requests to the `/categories/:categoryId` endpoint by retrieving a category from the `categoryCollection`
 * @param categoryId The ID of the category to retrieve
 * @returns The category with the specified ID, or an empty object if no such category exists
 */
export const getCategory = http.get<{ categoryId: string }, companyagreementApi.ProposalCreateVariables, object>(
  apiBaseUrl + '/categories/:categoryId',
  async ({ params }) => {
    try {
      const { categoryId } = params
      console.log('Received request for getCategory with params:', categoryId)
      const category = categoryCollection.findFirst((p) => p.where({ categoryId: categoryId }))

      if (!category) {
        return HttpResponse.json({})
      }

      return HttpResponse.json(category)
    } catch (error) {
      console.error('Error loading category:', error)
    }
  },
)
